import type { Signal } from '@angular/core';

import type { AppSectionId } from '@efficiently/client-core-routing';

export abstract class ProjectSurfaceAccessService {
	public abstract readonly grantedSurfaceIds: Signal<ReadonlySet<AppSectionId>>;
}
